$(document).ready(function(){

  /**** Star rating js ***/
  
    var data = $(".rating").attr("aria-label");
    var star = data.split(" ");    
        //console.log(star[0]);
    if(star > 0){
     $(".spr-badge").show();
    }else{
     $(".spr-badge").hide();
    }
  
  
  
  var products_on_page = $(".products-on-page");
var next_url = products_on_page.data("next-url");
//console.log("class"+next_url);

var load_more_btn = $(".load-more_btn");
var load_more_spiner = $(".load-more_spinner");

function loadMoreProducts () {
	$.ajax(
        {
            url: next_url,
            type:'GET',
            dataType:'html',
          beforeSend: function(){
          	load_more_btn.hide();
            load_more_spiner.show();
          }
        }
    ).done(function(next_page){
      
      load_more_spiner.hide();
      
        var new_products = $(next_page).find(".products-on-page");
        var new_url = new_products.data("next-url");
      //console.log("html"+new_url);
      
      if(new_url){
      	load_more_btn.show();
      }

        next_url = new_url;

        products_on_page.append(new_products.html());

    });
}
  
  
  
  
});